// extracted by mini-css-extract-plugin
export default {"container":"pCz3Cy","button":"NNSrvb","actionsContainer":"YN4enc","center":"wXQ0Dj","right":"UOkGdT","triangle":"_3KLaF","actionsPadding":"_UmLb7"};